export const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api';
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}

// Gemeinsamer Session-Vertrag für alle fetch-Aufrufe (auch außerhalb von request(), z.B.
// multipart-Uploads, die den JSON-Content-Type von request() nicht setzen dürfen): läuft die
// Session ab, leitet die App zum Login um statt einen rohen 401 durchzureichen.
export function assertAuthorized(res: Response, path: string): void {
  if (res.status === 401 && !path.startsWith('/v1/auth/')) {
    window.location.href = '/login';
    throw new ApiError(401, 'unauthorized');
  }
}

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
  });
  assertAuthorized(res, path);
  if (!res.ok) throw new ApiError(res.status, await res.text());
  // Antworten ohne Body (DELETE liefert 204 No Content) dürfen NICHT durch res.json() laufen —
  // das wirft auf leerem Body einen SyntaxError, die Mutation gilt als fehlgeschlagen und der
  // globale MutationCache zeigt einen Fehler-Toast, obwohl serverseitig alles geklappt hat
  // (und onSuccess/invalidate feuert nie, die Liste bleibt veraltet stehen).
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  return (text ? JSON.parse(text) : undefined) as T;
}
